import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
export function SocialProof() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#0f172a] text-white py-20 md:py-32" data-id="element-156">
      <div className="max-w-4xl mx-auto px-6" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-center" data-id="element-158">
          <div className="flex justify-center mb-6" data-id="element-159">
            <TrendingUpIcon className="w-12 h-12 text-[#d4a853]" data-id="element-160" />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-white" data-id="element-161">
            Resultados Comprobados
          </h2>

          <div className="bg-[#1e293b] p-8 md:p-12 rounded-xl shadow-2xl" data-id="element-162">
            <p className="text-xl md:text-2xl leading-relaxed text-gray-300" data-id="element-163">
              En solo{' '}
              <span className="text-[#d4a853] font-semibold" data-id="element-164">7 días</span>{' '}
              aplicando el enfriamiento biológico, el{' '}
              <span className="text-[#d4a853] font-bold text-3xl" data-id="element-165">85%</span> de
              las mujeres reportan que, aunque se despierten, logran conciliar
              el sueño en{' '}
              <span className="text-white font-semibold" data-id="element-166">
                menos de la mitad del tiempo habitual
              </span>
              , despertando sin la sensación de "resaca" matutina.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}